import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import {
  PhotoLibraryOutlined,
  AddBoxOutlined,
  FormatListNumbered,
} from '@material-ui/icons'
import { IMediaTypes } from '../../types/mediaTypes'
import { getMediaTypes } from '../../actions/mediaTypes'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import { CreateMediaTypeForm } from '../../forms'
import {
  CombinedTitle,
  TabsHead,
  View,
  SettingsMenu,
  H2,
} from '../../components'
import { AllMediaTypesTab } from './AllMediaTypesTab'
import { PrioritiesTab } from './PrioritiesTab'

export interface IMediaTypesPage {
  mediaTypes: IMediaTypes
  canViewAddMediaTypePage: boolean
  canViewMediaTypePrioritiesPage: boolean
  dispatch: Dispatch
}

export const MediaTypesPage = ({
  mediaTypes,
  canViewAddMediaTypePage,
  canViewMediaTypePrioritiesPage,
  dispatch,
}: IMediaTypesPage) => {
  useEffect(() => {
    dispatch(getMediaTypes())
  }, [dispatch])

  return (
    <Main
      sidebarSecondary={<SettingsMenu />}
      titleBlock={
        <>
          <CombinedTitle first="Media Types" second="Management" />
          <TabsHead
            tabs={[
              {
                label: 'All types',
                value: 'all-types',
                icon: <PhotoLibraryOutlined />,
              },
              ...(canViewAddMediaTypePage
                ? [
                    {
                      label: 'Add type',
                      value: 'add-type',
                      icon: <AddBoxOutlined />,
                    },
                  ]
                : []),
              ...(canViewMediaTypePrioritiesPage
                ? [
                    {
                      label: 'Priorities',
                      value: 'priorities',
                      icon: <FormatListNumbered />,
                    },
                  ]
                : []),
            ]}
          />
        </>
      }
      helmet="Administration: Media Types"
    >
      <View tab="all-types">
        <Scrollable>
          <H2 ml={2}>Media types</H2>
          <AllMediaTypesTab
            mediaTypesList={mediaTypes.list}
            dispatch={dispatch}
          />
        </Scrollable>
      </View>
      {canViewAddMediaTypePage && (
        <View keep tab="add-type">
          <Scrollable>
            <SettingFormsWrapper>
              <CreateMediaTypeForm />
            </SettingFormsWrapper>
          </Scrollable>
        </View>
      )}
      {canViewMediaTypePrioritiesPage && (
        <View tab="priorities">
          <Scrollable>
            <H2 ml={2}>Drag media types to set their priorities</H2>
            <PrioritiesTab />
          </Scrollable>
        </View>
      )}
    </Main>
  )
}
